import React, { useState } from 'react'
import { Map } from 'immutable'
import { connect } from 'react-redux'
import { getBoundActions } from '../../../actions/index'
import {
  VOTE_DIRECTION_DOWN,
  VOTE_DIRECTION_UP,
  VOTE_DIRECTION_LOVE,
  VOTE_DIRECTIONS,
  recommend,
} from '../../../services/recommend/index'
import { CONTENT_RATING_GA4_EVENT } from '../../../services/event-tracking/index'
import { getAuthIsLoggedIn } from '../../../services/auth/index'
import Button, { TYPES } from '../../Button/index'
import Heart from '../../Icon/icons/Heart/index'
import HeartFill from '../../Icon/icons/HeartFill/index'
import ThumbUpOutline from '../../Icon/icons/ThumbUpOutline/index'
import ThumbDownOutline from '../../Icon/icons/ThumbDownOutline/index'

/**
 * @param {Object} props - The props
 * @param {Map} props.detailData - The detail data
 * @param {Function} props.setEventDefault - The function to set the default GA4 event
 * @param {Object} props.ga4EventData - The GA4 event data
 * @param {Map} props.auth - The auth data
 * @returns {JSX.Element} DetailPageV3ActionVote
 */
function DetailPageV3ActionVote (props) {
  const {
    detailData = Map(),
    setEventDefault,
    ga4EventData,
    auth,
  } = props

  const jwt = auth.get('jwt')
  const isLoggedIn = getAuthIsLoggedIn(auth)
  const contentId = detailData.get('contentId')
  const userVote = detailData.get('userVote')

  const [vote, setVote] = useState(userVote ? VOTE_DIRECTIONS[userVote] : null)

  const handleVote = async (direction, ga4Rating) => {
    if (!isLoggedIn || vote === direction) {
      return
    }

    setVote(direction)

    await recommend({
      id: contentId,
      auth: jwt,
      vote: direction,
    })

    // GA4 EVENT
    if (ga4EventData) {
      setEventDefault(CONTENT_RATING_GA4_EVENT
        .mergeDeep(ga4EventData)
        .mergeDeep({ content_rating: ga4Rating }))
    }
  }

  return (
    <div className="detail-page-v3__action-buttons-group">
      <Button
        type={TYPES.ICON}
        iconSvg={vote === VOTE_DIRECTION_LOVE ? <HeartFill /> : <Heart />}
        onClick={() => handleVote(VOTE_DIRECTION_LOVE, 'love')}
        className={`detail-page-v3__action-button--heart ${vote === VOTE_DIRECTION_LOVE ? 'button--active' : ''}`}
      />
      <Button
        type={TYPES.ICON}
        iconSvg={<ThumbUpOutline />}
        onClick={() => handleVote(VOTE_DIRECTION_UP, 'up')}
        className={`detail-page-v3__action-button--up ${vote === VOTE_DIRECTION_UP ? 'button--active' : ''}`}
      />
      <Button
        type={TYPES.ICON}
        iconSvg={<ThumbDownOutline />}
        onClick={() => handleVote(VOTE_DIRECTION_DOWN, 'down')}
        className={`detail-page-v3__action-button--down ${vote === VOTE_DIRECTION_DOWN ? 'button--active' : ''}`}
      />
    </div>
  )
}

export default connect(
  (state) => ({
    auth: state.auth,
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      setEventDefault: actions.eventTracking.setEventDefault,
    }
  },
)(DetailPageV3ActionVote)
